<template>
  <div class="action-bar">
    <div class="spacer"></div>
    <div v-for="(action, index) in actions" :key="index" class="action">
      <div @click="action.event(action)" class="action-button">
        <fa-icon :icon="action.icon" size="2x" />
      </div>
      <div class="action-label">{{ action.label }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionBar',
  props: {
    actions: {
      type: Array, // actions[{ label, event(), icon{ type, name } }, ...],
      required: true,
    },
  },
};
</script>

<style lang="scss">
$action-bar-height: 100px;

.action-bar {
  user-select: none;

  display: flex;
  align-items: center;

  .spacer {
    flex-grow: 1;
  }

  .action {
    min-width: max-content;
    width: $action-bar-height / 1.5;

    margin: 10px 10px 0 10px;

    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .action-button {
    width: $action-bar-height / 1.5;
    height: $action-bar-height / 1.5;
    margin-bottom: 10px;

    border-radius: 50%;
    background-color: $year-color;
    @include flex-center();

    transition: transform 250ms;
    &:hover {
      cursor: pointer;
      transform: translateY(-5px);
    }
  }
}
</style>
